import { Button, Modal } from "@aqar-app/react-ui";
import css from "./.module.scss";
import { financialFormat } from "../../../lib/helpers";
import useIam, { DesiredServicesMap } from "@/hooks/useIam";
import { useRouter } from "next/router";
import { ClassicModal } from "./classicModal";
import { getIamModalProps } from "../../iam/isBlocked";
import { usePath } from "@/contexts/path/path";
import { useEffect, useMemo } from "react";
import Image from "next/image";
import { trackRNPLRentNow } from "@/lib/tracking/trackRNPLEvents";

const RnplProvidersLogos = () => {
  const showRizeFirst = useMemo(() => {
    const date = new Date();
    const hourSeed = date.getHours();
    const minuteSeed = date.getMinutes();
    return (hourSeed * 60 + minuteSeed) % 2 === 0;
  }, []);

  const rizeLogoElement = (
    <Image src="/rize_white-bg.png" alt="rize" width={60} height={28} />
  );

  const ejariLogoElement = (
    <svg
      width="60"
      height="28"
      viewBox="0 0 52 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="52" height="24" rx="3" fill="white" />
      <path
        d="M42.0005 14.9951H41.5195V17.5606H42.0005V14.9951Z"
        fill="#5DA883"
      />
      <path
        d="M35.4643 16.112C35.4046 16.1026 35.3431 16.0977 35.2803 16.0977C35.1925 16.0977 35.102 16.1086 35.0082 16.1306C34.9143 16.1526 34.8289 16.1877 34.7511 16.2359C34.6734 16.284 34.6097 16.3469 34.5596 16.4243C34.5097 16.5018 34.4847 16.5958 34.4847 16.7064C34.4847 16.7647 34.4967 16.8195 34.5207 16.8707C34.5447 16.9219 34.5754 16.97 34.6123 17.0153C34.6492 17.0604 34.6909 17.1025 34.7371 17.1412C34.7835 17.1799 34.8289 17.2158 34.8732 17.2491C34.9001 17.2706 34.9275 17.2926 34.9546 17.3152C34.9816 17.3378 35.0061 17.3617 35.0276 17.3867C35.0491 17.4117 35.0665 17.4372 35.0794 17.4634C35.0922 17.4894 35.0989 17.5158 35.0989 17.5419C35.0989 17.5979 35.0791 17.6506 35.0397 17.6999C35.0003 17.7493 34.9472 17.7923 34.8809 17.8293C34.8144 17.8662 34.7364 17.8951 34.6471 17.916C34.5579 17.9368 34.4633 17.9471 34.3637 17.9471C34.2171 17.9471 34.0904 17.9311 33.9839 17.899C33.8775 17.8669 33.7896 17.8228 33.7206 17.7668C33.6516 17.7109 33.6008 17.6452 33.5681 17.5695C33.5355 17.494 33.5191 17.4132 33.5191 17.3275C33.5191 17.2419 33.5332 17.1525 33.5616 17.0634C33.59 16.9741 33.6344 16.8931 33.6948 16.8206L33.3054 16.6154C33.2251 16.7176 33.1603 16.8333 33.1114 16.9626C33.0626 17.0917 33.0381 17.2229 33.0381 17.3561C33.0381 17.424 33.0474 17.4956 33.0659 17.5712C33.0845 17.6467 33.1146 17.7212 33.1564 17.7944C33.1985 17.8677 33.2536 17.9375 33.3221 18.0042C33.3905 18.0708 33.4739 18.1294 33.5718 18.1799C33.6698 18.2305 33.7845 18.271 33.9158 18.3013C34.0473 18.3317 34.1973 18.3467 34.3663 18.3467C34.492 18.3467 34.6097 18.3345 34.7188 18.3102C34.8278 18.2857 34.9278 18.2521 35.0185 18.2093C35.1092 18.1664 35.1896 18.1166 35.26 18.0593C35.3302 18.0022 35.3895 17.9415 35.4375 17.8773C35.4856 17.813 35.5222 17.746 35.5476 17.6764C35.5728 17.6068 35.5856 17.5387 35.5856 17.4722C35.5856 17.4282 35.5735 17.3838 35.5496 17.339C35.5256 17.2944 35.4949 17.2512 35.458 17.2096C35.421 17.168 35.3801 17.1278 35.3351 17.0891C35.2899 17.0504 35.2465 17.0151 35.2046 16.9828C35.1775 16.9614 35.1495 16.9384 35.1204 16.9141C35.0913 16.8896 35.0653 16.8649 35.0418 16.8401C35.0183 16.8151 34.9992 16.7897 34.9844 16.764C34.9695 16.7385 34.9621 16.7139 34.9621 16.69C34.9621 16.6497 34.9723 16.616 34.9928 16.5892C35.0131 16.5625 35.0386 16.541 35.0695 16.525C35.1003 16.5089 35.1335 16.4974 35.1693 16.4902C35.205 16.4829 35.2389 16.4793 35.271 16.4793C35.3106 16.4793 35.3536 16.4853 35.4006 16.4973C35.4475 16.5092 35.4905 16.5216 35.5301 16.5348C35.5769 16.5515 35.6238 16.5699 35.6707 16.5902L35.7798 16.1886C35.7318 16.172 35.68 16.157 35.6245 16.1438C35.5776 16.132 35.5243 16.1211 35.4645 16.1117L35.4643 16.112Z"
        fill="#5DA883"
      />
      <path
        d="M34.791 18.611C34.7695 18.5901 34.7444 18.5739 34.7161 18.5619C34.6877 18.5499 34.6569 18.5439 34.6234 18.5439C34.59 18.5439 34.5594 18.5499 34.531 18.5619C34.5025 18.5739 34.4776 18.5901 34.4561 18.611C34.4345 18.6318 34.4175 18.6558 34.4051 18.6832C34.3927 18.7105 34.3867 18.7403 34.3867 18.7725C34.3867 18.8048 34.3928 18.8344 34.4051 18.8619C34.4174 18.8895 34.4345 18.9135 34.4561 18.9342C34.4776 18.955 34.5025 18.9714 34.531 18.9832C34.5592 18.9952 34.5902 19.0012 34.6234 19.0012C34.6567 19.0012 34.6875 18.9952 34.7161 18.9832C34.7444 18.9712 34.7695 18.9549 34.791 18.9342C34.8125 18.9135 34.8295 18.8893 34.8418 18.8619C34.8542 18.8346 34.8603 18.8048 34.8603 18.7725C34.8603 18.7403 34.8542 18.7107 34.8418 18.6832C34.8295 18.6558 34.8125 18.6316 34.791 18.611Z"
        fill="#5DA883"
      />
      <path
        d="M34.2353 18.611C34.2138 18.5901 34.1888 18.5739 34.1606 18.5619C34.1322 18.5499 34.1014 18.5439 34.0679 18.5439C34.0345 18.5439 34.0039 18.5499 33.9753 18.5619C33.9468 18.5739 33.9219 18.5901 33.9004 18.611C33.8789 18.6318 33.8619 18.6558 33.8496 18.6832C33.8372 18.7105 33.8311 18.7403 33.8311 18.7725C33.8311 18.8048 33.8372 18.8344 33.8496 18.8619C33.8619 18.8893 33.8789 18.9135 33.9004 18.9342C33.9219 18.955 33.947 18.9714 33.9753 18.9832C34.0037 18.9952 34.0345 19.0012 34.0679 19.0012C34.1014 19.0012 34.132 18.9952 34.1606 18.9832C34.1888 18.9712 34.2138 18.9549 34.2353 18.9342C34.2569 18.9135 34.2739 18.8893 34.2863 18.8619C34.2987 18.8346 34.3048 18.8048 34.3048 18.7725C34.3048 18.7403 34.2987 18.7107 34.2863 18.6832C34.2739 18.6556 34.2569 18.6316 34.2353 18.611Z"
        fill="#5DA883"
      />
      <path
        d="M36.4248 17.3286C36.4248 17.4119 36.4183 17.4849 36.4054 17.5474C36.3924 17.6099 36.3674 17.664 36.3304 17.7098C36.2935 17.7555 36.2417 17.7939 36.1749 17.825C36.1084 17.8559 36.0214 17.8816 35.9141 17.9017L35.9734 18.2979C36.1399 18.2729 36.2819 18.2361 36.3998 18.1872C36.5176 18.1382 36.6141 18.0723 36.6892 17.9891C36.7643 17.9058 36.8193 17.8025 36.8539 17.6793C36.8884 17.5562 36.9058 17.4083 36.9058 17.2357V16.0967H36.4248V17.3284V17.3286Z"
        fill="#5DA883"
      />
      <path
        d="M39.2099 17.9107C39.1884 17.8899 39.1634 17.8735 39.135 17.8615C39.1066 17.8495 39.0758 17.8438 39.0424 17.8438C39.0089 17.8438 38.9783 17.8497 38.9498 17.8615C38.9212 17.8733 38.8964 17.8899 38.875 17.9107C38.8535 17.9314 38.8365 17.9554 38.824 17.983C38.8116 18.0102 38.8057 18.0401 38.8057 18.0722C38.8057 18.1043 38.8118 18.134 38.824 18.1616C38.8363 18.1891 38.8535 18.2131 38.875 18.2339C38.8965 18.2547 38.9214 18.2711 38.9498 18.2829C38.9781 18.2949 39.0091 18.3008 39.0424 18.3008C39.0757 18.3008 39.1065 18.2949 39.135 18.2829C39.1634 18.2711 39.1884 18.2547 39.2099 18.2339C39.2315 18.2131 39.2485 18.1889 39.2607 18.1616C39.2731 18.1342 39.2793 18.1045 39.2793 18.0722C39.2793 18.0399 39.2731 18.0103 39.2607 17.983C39.2483 17.9554 39.2313 17.9314 39.2099 17.9107Z"
        fill="#5DA883"
      />
      <path
        d="M41.0371 16.0959H40.556V17.1688H39.9232C39.8936 17.1688 39.8686 17.1532 39.8483 17.1223C39.828 17.0914 39.8105 17.05 39.7956 16.9983C39.7807 16.9464 39.7674 16.8869 39.7558 16.8197C39.7441 16.7525 39.7327 16.682 39.7215 16.6082C39.7066 16.5188 39.6811 16.4367 39.6448 16.3618C39.6084 16.2868 39.5606 16.2222 39.5014 16.168C39.4423 16.1139 39.3713 16.0717 39.2887 16.0413C39.2061 16.011 39.1112 15.9958 39.0038 15.9958C38.8965 15.9958 38.7978 16.0051 38.7116 16.0235C38.6253 16.042 38.539 16.0638 38.4525 16.0888V16.4564C38.4894 16.4411 38.5295 16.4274 38.5726 16.4154C38.6158 16.4035 38.658 16.3939 38.6994 16.3868C38.7407 16.3797 38.7799 16.3743 38.8168 16.3708C38.8538 16.3672 38.8853 16.3654 38.9112 16.3654C38.9876 16.3654 39.0494 16.3821 39.0961 16.4154C39.143 16.4487 39.1807 16.4919 39.209 16.5448C39.2374 16.5979 39.2586 16.6577 39.2728 16.7242C39.287 16.791 39.299 16.8575 39.3088 16.9243C39.3162 16.9694 39.3272 17.0135 39.3421 17.0562C39.357 17.0992 39.3722 17.1367 39.3885 17.1688H38.0879C38.051 17.1688 38.0186 17.1642 37.9908 17.1553C37.9629 17.1463 37.9402 17.1306 37.9223 17.1079C37.9045 17.0853 37.891 17.0547 37.8817 17.016C37.8724 16.9773 37.8677 16.9282 37.8677 16.8689V14.9961H37.3867V16.967C37.3867 17.0551 37.3979 17.1357 37.42 17.209C37.4422 17.2821 37.4771 17.3447 37.5245 17.3964C37.572 17.4482 37.6324 17.4883 37.7059 17.5168C37.7794 17.5454 37.8677 17.5597 37.9713 17.5597H41.037V16.0959H41.0371Z"
        fill="#5DA883"
      />
      <path
        d="M40.6152 17.9107C40.5937 17.8899 40.5686 17.8735 40.5403 17.8615C40.5119 17.8495 40.4811 17.8438 40.4477 17.8438C40.4142 17.8438 40.3836 17.8497 40.3552 17.8615C40.3268 17.8735 40.3018 17.8899 40.2803 17.9107C40.2587 17.9314 40.2418 17.9554 40.2293 17.983C40.2171 18.0102 40.2109 18.0401 40.2109 18.0722C40.2109 18.1043 40.2171 18.134 40.2293 18.1616C40.2418 18.1889 40.2587 18.2131 40.2803 18.2339C40.3018 18.2547 40.3268 18.2711 40.3552 18.2829C40.3834 18.2949 40.4144 18.3008 40.4477 18.3008C40.4809 18.3008 40.5117 18.2949 40.5403 18.2829C40.5686 18.2711 40.5937 18.2547 40.6152 18.2339C40.6368 18.2131 40.6537 18.1889 40.666 18.1616C40.6784 18.1342 40.6846 18.1045 40.6846 18.0722C40.6846 18.0399 40.6784 18.0103 40.666 17.983C40.6537 17.9554 40.6368 17.9314 40.6152 17.9107Z"
        fill="#5DA883"
      />
      <path
        d="M41.1699 17.9107C41.1484 17.8899 41.1233 17.8735 41.095 17.8615C41.0666 17.8495 41.0358 17.8438 41.0025 17.8438C40.9693 17.8438 40.9384 17.8497 40.9099 17.8615C40.8814 17.8733 40.8565 17.8899 40.835 17.9107C40.8134 17.9314 40.7964 17.9554 40.7842 17.983C40.7718 18.0102 40.7656 18.0401 40.7656 18.0722C40.7656 18.1043 40.7718 18.134 40.7842 18.1616C40.7964 18.1889 40.8134 18.2131 40.835 18.2339C40.8565 18.2547 40.8815 18.2711 40.9099 18.2829C40.9383 18.2949 40.9691 18.3008 41.0025 18.3008C41.036 18.3008 41.0666 18.2949 41.095 18.2829C41.1233 18.2711 41.1484 18.2547 41.1699 18.2339C41.1914 18.2131 41.2084 18.1889 41.2209 18.1616C41.2331 18.1342 41.2392 18.1045 41.2392 18.0722C41.2392 18.0399 41.2331 18.0103 41.2209 17.983C41.2084 17.9554 41.1914 17.9314 41.1699 17.9107Z"
        fill="#5DA883"
      />
      <path
        d="M25.445 12.876L25.1123 13.751H27.779L27.4511 12.876H25.445Z"
        fill="#5DA883"
      />
      <path
        d="M27.5301 5.00098H25.3987L21.5566 12.876H23.0945L26.37 6.32959L29.6346 12.876H31.3344L27.5301 5.00098Z"
        fill="#5DA883"
      />
      <path
        d="M10.001 12.8758V5.00098H15.1424V6.27591H11.6618V8.27153H14.4463V9.48185H11.6618V11.5849H15.3343V12.876H10.001V12.8758Z"
        fill="#175965"
      />
      <path
        d="M17.7157 12.876C17.1071 12.876 16.6097 12.7962 16.2236 12.6369V11.3988C16.5973 11.5229 16.9874 11.5849 17.3946 11.5849C18.2885 11.5849 18.7354 11.1597 18.7354 10.3097V5.00098H20.6681V10.3412C20.6681 11.1843 20.4087 11.8177 19.8907 12.2409C19.3724 12.6643 18.6473 12.876 17.7157 12.876Z"
        fill="#175965"
      />
      <path
        d="M33.1123 12.876V5.00098H35.8694C36.8027 5.00098 37.5362 5.19653 38.0696 5.5873C38.6028 5.97824 38.8696 6.56456 38.8696 7.34627V7.38929C38.8696 7.9631 38.7193 8.42122 38.4184 8.76366C38.1173 9.1061 37.711 9.34913 37.1993 9.49258L39.3345 12.876H37.583L35.6153 9.7668H34.7503V12.876H33.1123ZM34.7503 8.63717H35.837C36.7885 8.63717 37.2642 8.23904 37.2642 7.44293V7.39991C37.2642 6.99098 37.1443 6.6979 36.9047 6.52034C36.665 6.34278 36.3127 6.25418 35.8478 6.25418H34.7503V8.637V8.63717Z"
        fill="#175965"
      />
      <path
        d="M40.2236 12.8758V5.00098H42.0014V12.876H40.2236V12.8758Z"
        fill="#175965"
      />
      <path
        d="M31.8252 16.8791H10.001V17.8309H31.8252V16.8791Z"
        fill="#5DA883"
      />
    </svg>
  );

  return (
    <div className={css.logos}>
      {showRizeFirst ? rizeLogoElement : ejariLogoElement}
      {showRizeFirst ? ejariLogoElement : rizeLogoElement}
    </div>
  );
};

function RnplSeekerControls({ rnpl_monthly_price, id }) {
  const router = useRouter();
  const { iamStatus, checkingStatus } = useIam();
  const { category, listingType, previousPath } = usePath();

  useEffect(() => {
    trackRNPLRentNow({
      source: previousPath || decodeURI(document.referrer),
    });
  }, []);

  const openIAMVerificationModal = () => {
    const { children, title } = getIamModalProps({
      desiredService: DesiredServicesMap.rnpl,
    });
    Modal.open(<ClassicModal title={title} body={children} />)();
  };

  const rentNow = (e) => {
    // if (!iamStatus) {
    //   Modal.open(
    //     <ClassicModal
    //       title="توثيق حسابي"
    //       body={
    //         <div>
    //           الرجاء توثيق الحساب بالنفاذ الوطني لتتمكن من استخدام هذه الخدمة
    //         </div>
    //       }
    //       ok={{
    //         label: "حسنا",
    //         cb: (ev) => {
    //           Modal.close(e);
    //           openIAMVerificationModal();
    //         },
    //       }}
    //     />,
    //   )(e);
    //   return;
    // }
    // trackRNPLApply({
    //   listingType,
    //   category: category?.ga_property_category,
    //   source: previousPath || decodeURI(document.referrer),
    // });
    trackRNPLRentNow({
      source: previousPath || decodeURI(document.referrer),
    });
    router.push(
      `/rnpl/seek?id=${id}&listing_type=${listingType}&category=${category?.ga_property_category}`,
    );
  };

  return (
    <div className={css.rnplSeekerControls}>
      <div className={css.card + " " + css.rnlpCard}>
        <div className={css.right}>
          <RnplProvidersLogos />

          <span>
            استأجر الآن وأدفع لاحقًا ابتداءً من
            <strong>
              {financialFormat(rnpl_monthly_price, "ريال")} شهريًا
            </strong>
          </span>
        </div>
        <Button theme="primary" onClick={rentNow}>
          استأجر الآن
        </Button>
      </div>
      {/*<p className={css.disclaimer}>*/}
      {/*  قد تختلف الدفعة الشهرية بناء على حالة المتقدم*/}
      {/*</p>*/}
    </div>
  );
}

export default RnplSeekerControls;
